import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.last-index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _typeof from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/createClass";
import cookies from './util.cookies';
import txim from './d.txim';
import db from './util.db';
import log from './util.log';
import Dates from './d.dates';
import Helper from './d.helper';
import { formatTime } from './util.time';
import { Message } from 'element-ui';
import md5 from 'md5';
import { cloneDeep } from 'lodash';

var Util = /*#__PURE__*/function () {
  function Util() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Util);

    this.version = '1.0.0';
    this.global = {};

    for (var key in options) {
      if (!this[key]) {
        // 防止原有方法被修改
        this[key] = options[key];
      }
    }
  }

  _createClass(Util, [{
    key: "set",
    value: function set(key, val) {
      var storage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.global[key] = val;

      if (storage) {
        localStorage.setItem(key, _typeof(val) === 'object' ? JSON.stringify(val) : val);
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      var storage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var out = this.global[key];

      if (storage && !out) {
        // out 没值就去获取storage的
        out = localStorage.getItem(key);

        try {
          out = JSON.parse(out);
        } catch (error) {}
      }

      return out || '';
    }
  }]);

  return Util;
}();

var util = new Util(_objectSpread(_objectSpread({
  cookies: cookies,
  txim: txim,
  db: db,
  log: log,
  formatTime: formatTime
}, Dates), Helper));
txim.initSDK(txim.sdkAppId);
/**
 * @description md5加密
 * @param {String} text 需要加密的数据
 */

util.md5 = function (text) {
  var assginText = "".concat(text).concat(process.env.VUE_APP_LOGIN_SALT);
  return md5(assginText);
};
/**
 * @description 更新标题
 * @param {String} title 标题
 */


util.title = function (titleText) {
  var processTitle = process.env.VUE_APP_TITLE || 'D2Admin';
  window.document.title = "".concat(titleText ? "".concat(titleText, " - ") : '系统首页 - ').concat(processTitle);
};
/**
 * @description 打开新页面
 * @param {String} url 地址
 */


util.open = function (url) {
  var a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('target', '_blank');
  a.setAttribute('id', 'd2admin-link-temp');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(document.getElementById('d2admin-link-temp'));
};
/**
 * @description element message
 * @param {String} text 提示文字
 * @param {String} type 提示类型
 */


util.message = function (text) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
  Message({
    type: type,
    message: text
  });
};
/**
 * @description 简单copy功能实现
 */


util.copyThat = function (data) {
  var url = data;
  var oInput = document.createElement('input');
  oInput.value = url;
  document.body.appendChild(oInput);
  oInput.select(); // 选择对象;

  document.execCommand('Copy'); // 执行浏览器复制命令

  Message.success('复制成功！');
  oInput.remove();
};
/**
 * @description 判断数据是否为空
 * @param {String} any
 */


util.isEmpty = function (v) {
  switch (_typeof(v)) {
    case 'undefined':
      return true;

    case 'string':
      if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length === 0) return true;
      break;

    case 'boolean':
      if (!v) return true;
      break;

    case 'number':
      if (v === 0 || isNaN(v)) return true;
      break;

    case 'object':
      if (v === null || v.length === 0) return true;

      for (var i in v) {
        return false;
      }

      return true;
  }

  return false;
};
/**
 * @description 商家入驻状态判断
 * @param {String} any
 */


util.isStoreAuto = function (status) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var s = cloneDeep(status);
  var mapStatus = [{
    label: '未申请',
    value: 0,
    key: 'settled'
  }, {
    label: '已申请',
    value: 1,
    key: 'resident'
  }, {
    label: '审核通过',
    value: 2,
    key: 'resSucc'
  }, {
    label: '已完善信息',
    value: 3,
    key: 'payment'
  }, {
    label: '已缴纳保证金',
    value: 4,
    key: 'examine'
  }, {
    label: '保证金审核失败',
    value: 5,
    key: 'examineError'
  }, {
    label: '保证金审核成功',
    value: 6,
    key: 'index'
  }, {
    label: '入驻审核未通过',
    value: 7,
    key: 'resError'
  }];
  var routeKey = mapStatus.find(function (v) {
    return v.value == s;
  });
  type && app.goRoute(routeKey.key);
  return routeKey;
};
/**
 * @description 上传类型封装
 * @param {String} any
 */


util.beforeUploadCommon = function (file, type) {
  var fileName = file.name;
  var pos = fileName.lastIndexOf('.');
  var lastName = fileName.substring(pos, fileName.length); // 获取文件后缀

  var typeObj = {
    audio: function audio() {
      if (!/\.(m4a|aac|mp3|wav)$/.test(lastName.toLowerCase())) {
        Message.error('音频文件类型只支持m4a、aac、mp3、wav格式');
        return false;
      } else return true;
    },
    video: function video() {
      if (!/\.(mp4|3gp|m3u8)$/.test(lastName.toLowerCase())) {
        Message.error('音频文件类型只支持mp4、3gp、m3u8格式');
        return false;
      } else return true;
    },
    pic: function pic() {
      if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(lastName.toLowerCase())) {
        Message.error('图片文件类型只支持png、jpeg、jpg格式');
        return false;
      } // const kSize = file.size / 1024 < 600
      // if (!kSize) {
      //   Message.error('图片大小不能超过600K')
      //   return false
      // }


      return true;
    }
  };

  try {
    return typeObj[type]();
  } catch (e) {
    console.log('错误');
    Message.error('上传错误，请联系管理员');
  }
};
/**
 * @description 获取文件后缀类型
 * @param {String} any
 */


util.catchType = function (sourceName) {
  var typestr = sourceName.toLowerCase().substring(sourceName.lastIndexOf('.'));
  return typestr;
};
/**
 * @description 传入一个树形数据找出所属的id集合
 * @param {Any} value 需要处理的值
 */


util.getTreeId = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var nodeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var config = arguments.length > 2 ? arguments[2] : undefined;

  var _ref = config || {},
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? 'children' : _ref$children,
      _ref$keyId = _ref.keyId,
      keyId = _ref$keyId === void 0 ? 'id' : _ref$keyId;

  var targetList = [];

  var conver = function conver(arr, selectList) {
    return arr === null || arr === void 0 ? void 0 : arr.map(function (m) {
      //暂存集合
      var _selectList = [].concat(_toConsumableArray(selectList), [m[keyId]]);

      if (m[keyId] == nodeId) targetList = _toConsumableArray(_selectList);
      return _objectSpread(_objectSpread({}, m), {}, {
        children: conver(m === null || m === void 0 ? void 0 : m[children], _selectList)
      });
    });
  };

  conver(data, []);
  return targetList;
};

export default util;